var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarehouses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.75 24h-6.75c-.414 0-.75-.336-.75-.75v-5.5c0-.414.336-.75.75-.75h6.75c.414 0 .75.336.75.75v5.5c0 .414-.336.75-.75.75zm-6-1.5h5.25v-4h-5.25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.25 18.5h-6.5c-.414 0-.75-.336-.75-.75v-6c0-.414.336-.75.75-.75h6.5c.414 0 .75.336.75.75v6c0 .414-.336.75-.75.75zm-5.75-1.5h5v-4.5h-5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m12 24h-6.75c-.414 0-.75-.336-.75-.75v-5.5c0-.414.336-.75.75-.75h6.75c.414 0 .75.336.75.75v5.5c0 .414-.336.75-.75.75zm-6-1.5h5.25v-4h-5.25z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m12 14c-.414 0-.75-.336-.75-.75v-1.5c0-.414.336-.75.75-.75s.75.336.75.75v1.5c0 .414-.336.75-.75.75z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m8.75 20c-.414 0-.75-.336-.75-.75v-1.5c0-.414.336-.75.75-.75s.75.336.75.75v1.5c0 .414-.336.75-.75.75z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m15.25 20c-.414 0-.75-.336-.75-.75v-1.5c0-.414.336-.75.75-.75s.75.336.75.75v1.5c0 .414-.336.75-.75.75z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m22.25 24h-20.5c-.965 0-1.75-.785-1.75-1.75v-13.75c0-.247.122-.478.325-.618l11.25-7.75c.256-.177.595-.177.851 0l11.25 7.75c.202.14.324.371.324.618v13.75c0 .965-.785 1.75-1.75 1.75zm-20.75-15.106v13.356c0 .138.112.25.25.25h20.5c.138 0 .25-.112.25-.25v-13.356l-10.5-7.233z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouses);
export default __webpack_public_path__ + "static/media/Warehouses.53f067a2.svg";
export { ForwardRef as ReactComponent };